import React,{useState,useEffect} from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import "./Footer.css"
import { FaFacebookF } from 'react-icons/fa';
import { AiOutlineTwitter } from 'react-icons/ai';
import { BiEnvelope } from 'react-icons/bi';
import { GoLocation } from 'react-icons/go';
import { BsChatDotsFill } from 'react-icons/bs';






const Footer = () => {
const [email,setEmail] = useState("");
const [message, setMessage] = useState("");
const restore = (e) => {
   e.preventDefault();
   setEmail(" ");
   setMessage(" ");
}
 return (
  <>
  
    
  
   <div className="container-fluid  bg-light mt-5 py-3 px-3">
    <div className="footer-head container">
    <div className="logos">
    <Logo />
    </div>
    <div className="footer-icons">
    <div className="footer-icon">
    < FaFacebookF />
    </div>
    <div className="footer-icon">
       < AiOutlineTwitter />
    </div>
    <div className="footer-icon">
       < BiEnvelope />
    </div>
      
    </div>
    </div>
   
   <hr className=" hr"/>
   <div className="row"> 
      <div className="col-lg-3  pl-4">
      <h3 className="text-dark "><b> Talk with Us?</b></h3>
      <p className="text-dark ">
      we are always at your service
      </p>
                <div className="footer-location ">
                   <div className="coly mr-3 text-center">
                      < GoLocation  className="footer-icony text-primary"/>
                   </div>
                   <div className="colu">
                      <h6 className="text-dark ">Victoria Island Lagos</h6>
                      <p className="text-dark ">Nigeria</p>
                   </div>
                </div>
                <div className="footer-location ">
                   <div className="coly mr-3 text-center">
                      < BsChatDotsFill  className="footer-icony text-primary"/>
                   </div>
                   <div className="colu">
                      <h6 className="text-dark  ">+(234) 9030909624</h6>
                      <p className="text-dark text-center">starlordflash@gmail.com</p>
                   </div>
                </div>
      </div>
      <div className="col-lg-3  pl-4">
                <h3 className="text-dark "><b>Our Company</b></h3>
                <ul>
                   <li className="my-3">About us</li>
                   <li className="my-3">Contact us</li>
                   <li className="my-3">Our Technology</li>
                   <li className="my-3">Latest Blog</li>
                </ul>
      </div>
      <div className="col-lg-3  pl-4">
                <h3 className="text-dark "><b>Our Services</b></h3>
                <ul>
                   <li className="my-3">Analystics Program</li>
                   <li className="my-3">Web Development</li>
                   <li className="my-3">UI/UX Design</li>
                   <li className="my-3">Web Hosting</li>
                   <li className="my-3">Mobile Development</li>
                </ul>
      </div>
      <div className="col-lg-3  pl-4">
         <h3 className="text-dark"><b>About Us</b></h3>
                <form onSubmit={restore} >
                   <input type="text" value={email}
                      className="text-area form-control my-2" placeholder="Email" onChange={(e) => {
                         setEmail(e.target.value)
                      }} />
                   <input type="text" value={message}
                      className="text-area form-control my-2" placeholder="Message" onChange={(e) => {
                         setMessage(e.target.value)
                      }} />
                
                   <Link to="/feedback" className="btn btn-primary btn-outline-none  mx-auto" type="submit" onClick={() => {
                      setMessage("");
                      setEmail("");
                   }}>Send Feedback</Link>
                </form>
        
      </div>

   </div>

   </div>
   <div className="container-fluid footer-foot bg-primary py-3">
   <p className="text-white my-auto">© Copyright Daniekeys Technology 2021</p>
   </div>

   
  </>
 )
}

export default Footer